import React from "react";

import { masterColumnSet } from "./houseColumns";

import DataTablesEditor from "../DatatablesEditor/DataTablesEditor";

import { baseURL } from "../../../apis/dvdlocator";

class HouseReceived extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchValue: this.props.match.params.search
        ? this.props.match.params.search
        : "",
      columns: masterColumnSet,
      colSets: [],

      fields: masterColumnSet,

      options: {
        dom: "Blrtip", // https://datatables.net/reference/option/dom
        processing: true,
        serverSide: true,
        select: true,
        paging: true,
        paginate: true,
        pageLength: 50,
        lengthChange: true,
        scrollX: true,
        scrollY: window.innerHeight - 200,
        scrollCollapse: true,
        autoWidth: true,

        // 	stateSave: true,
        colReorder: true,
        deferRender: true,
        order: [[1, "asc"]],
      },
    };

    this.dataTablesRef = React.createRef();
  }

  componentDidMount() {
    // run initial search if one given
    if (this.state.searchValue) {
      this.dataTablesRef.current.search(this.state.searchValue);
    }
  }

  // search field onChange event handler
  onChangeSearch = (e) => {
    const { value } = e.target;
    const searchValue = value;
    this.setState({ searchValue });

    clearTimeout(this.searchDelay);
    console.log(this.state.searchValue);
    this.searchDelay = setTimeout(() => {
      this.dataTablesRef.current.search("");
    }, 1000);
  };

  customButtons = () => {
    return [
      {
        text: "<span title='Refresh Table'>Refresh</span>",
        action: (e, dt, node, config) => {
          dt.ajax.reload();
        },
      },
    ];
  };

  render() {
    const { fields, columns, options, searchValue } = this.state;

    return (
      <div>
        <div className="ui input">
          <input
            value={searchValue}
            onChange={this.onChangeSearch}
            autoComplete={"off"}
            type="text"
            placeholder="Search ..."
          />
        </div>
        <DataTablesEditor
          key={this.state.render}
          ref={this.dataTablesRef}
          ajax={{
            url: `${baseURL}/datatables/house-received`,
            contentType: "application/json",
            type: "POST",
            data: (d) => {
              d.smartSearch = this.state.searchValue;
              return JSON.stringify(d);
            },
          }}
          editorAjax={{
            url: `${baseURL}/datatables/house-received`,
            contentType: "application/json",
            type: "POST",
            data: function (d) {
              return JSON.stringify(d);
            },
          }}
          columns={columns}
          options={options}
          fields={fields}
          createButton={false}
          editButton={true}
          removeButton={true}
          customButtons={this.customButtons}
          exportButton={true}
          colVis={false}
        />
      </div>
    );
  }
}

export default HouseReceived;
